import { render, staticRenderFns } from "./RestaurantImage.vue?vue&type=template&id=6951b881"
import script from "./RestaurantImage.vue?vue&type=script&lang=js"
export * from "./RestaurantImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports